import styles from './CompanyCell.module.scss';

interface ICompanyCellProps {
  code: string;
  description: string;
}

function CompanyCell({ code, description }: ICompanyCellProps) {
  return (
    <>
      <div className={styles.companyName}>{description}</div>
      <div className={styles.companyCode}>{code}</div>
    </>
  );
}

export default CompanyCell;
